/**
 * 实时聊天信息
 */

import type { LiveChatFirstPage } from '@/plugins/utils'

export const useRoomList = () => useState<Msg.IRoom[]>('room_list', () => ([]))
export const useCurrentMsgList = () => useState<Msg.IMsgContent[]>('current_msg_list', () => [])
export const useNotificationsTabs = () => useState<Msg.IMsgTabs[]>('notifications', () => [])
export const useConnectStatus = () => useState<
  'disconnect' | 'reconnecting' | 'reconnect_failed' | 'success' | 'connect_error'
>('connect_status', () => 'success')

/** PC */
export const usePCLiveChatPopupShow = () => useState<boolean>('pc_popup_show', () => false)
export const usePCCurrentChatRoom = () => useState<Msg.IRoom | null>('pc_current_chat_room', () => null)
export const usePCRoomMsgList = () => useState<{ [key: string]: Msg.IMsgContent[] }>('pc_room_msg_list', () => ({}))
export const useLiveChatFirstPage = () => useState<LiveChatFirstPage | null>('live_chat_first_page', () => null)

export const usePCOpenRoomInfo = () => useState<{
  source: string,
  msgType: number,
  chatFirstPage?: LiveChatFirstPage,
  order?: Msg.IMsgOrder,
  product?: Msg.IMsgProduct,
  store?: Pick<Msg.IMsgProduct, 'storeId' | 'storeName' | 'storeIcon'>
} | null>('pc_open_room_info', () => null)

export const useMessageNotReadTotal = () => useState<number>('message_not_read_total', () => 0)

export const useSSQ = () => useState<any>('salesmartly_ssq', () => window.ssq)
export const useSSQunRead = () => useState<any>('salesmartly_ssq_unread', () => 0)